import React from "react"
import styled from "styled-components"

const Wrapper = styled.div`
  display: flex;
  height: 568px;
  align-items: center;
  align-self: stretch;

  border-radius: 8px;
  border: 1px solid var(--base-gray20, #dedede);
  background: var(--base-white50, rgba(255, 255, 255, 0.5));

  flex-direction: column;
`

const Row = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
`

const Column = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #262626;
  background: var(--secondary10, #eef1f9);
  border: 1px solid var(--base-gray10, #e8e8e8);
`

const Cell = styled.div`
  flex: 1;
  display: flex;
  justify-content: center; /* 수평 가운데 정렬 */
  align-items: center; /* 수직 가운데 정렬 */
  border: 1px solid var(--base-gray20, #e8e8e8);
  color: #404040; /* 잘못된 따옴표 제거 */
  text-align: center; /* 텍스트 가운데 정렬 */
`

interface Props {
  대전Data: any
  보령Data: any
  여수Data: any
  정읍Data?: any
}

const Page2Table = (props: Props) => {
  const { 대전Data, 보령Data, 여수Data, 정읍Data } = props

  return (
    <Wrapper>
      <Row>
        <Column>마을명</Column>
        <Column>정읍</Column>
        <Column>대전</Column>
        <Column>보령</Column>
        <Column>여수</Column>
      </Row>
      <Row>
        <Cell>자립률 달성을 위한 초과/부족량 [MWh]</Cell>
        <Cell>
          {Number(정읍Data?.excessGen?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(대전Data?.excessGen?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(보령Data?.excessGen?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(여수Data?.excessGen?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
      </Row>
      <Row>
        <Cell>마을간 거래 판매량 [MWh]</Cell>
        <Cell>
          {Number(정읍Data?.sellTown?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(대전Data?.sellTown?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(보령Data?.sellTown?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(여수Data?.sellTown?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
      </Row>
      <Row>
        <Cell>마을간 거래 구매량 [MWh]</Cell>
        <Cell>
          {Number(정읍Data?.buyTown?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(대전Data?.buyTown?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(보령Data?.buyTown?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(여수Data?.buyTown?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
      </Row>
      <Row>
        <Cell>계통판매량 [MWh]</Cell>
        <Cell>
          {Number(정읍Data?.sellGrid?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(대전Data?.sellGrid?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(보령Data?.sellGrid?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(여수Data?.sellGrid?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
      </Row>
      <Row>
        <Cell>계통구매량 [MWh]</Cell>
        <Cell>
          {Number(정읍Data?.buyGrid?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(대전Data?.buyGrid?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(보령Data?.buyGrid?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(여수Data?.buyGrid?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
      </Row>
      <Row>
        <Cell>마을간 거래 판매금액 [원]</Cell>
        <Cell>
          {정읍Data?.tradeList
            ? Number(
                정읍Data.tradeList
                  .reduce(
                    (sum: number, trade: any) => sum + (trade.sellCost || 0),
                    0
                  )
                  .toFixed(0) || 0
              ).toLocaleString()
            : 0}
        </Cell>
        <Cell>
          {대전Data?.tradeList
            ? Number(
                대전Data.tradeList
                  .reduce(
                    (sum: number, trade: any) => sum + (trade.sellCost || 0),
                    0
                  )
                  .toFixed(0) || 0
              ).toLocaleString()
            : 0}
        </Cell>
        <Cell>
          {보령Data?.tradeList
            ? Number(
                보령Data.tradeList
                  .reduce(
                    (sum: number, trade: any) => sum + (trade.sellCost || 0),
                    0
                  )
                  .toFixed(0) || 0
              ).toLocaleString()
            : 0}
        </Cell>
        <Cell>
          {여수Data?.tradeList
            ? Number(
                여수Data.tradeList
                  .reduce(
                    (sum: number, trade: any) => sum + (trade.sellCost || 0),
                    0
                  )
                  .toFixed(0) || 0
              ).toLocaleString()
            : 0}
        </Cell>
      </Row>
      <Row>
        <Cell>마을간 거래 구매금액 [원]</Cell>
        <Cell>
          {정읍Data?.tradeList
            ? Number(
                정읍Data.tradeList
                  .reduce(
                    (sum: number, trade: any) => sum + (trade.buyCost || 0),
                    0
                  )
                  .toFixed(0) || 0
              ).toLocaleString()
            : 0}
        </Cell>
        <Cell>
          {대전Data?.tradeList
            ? Number(
                대전Data.tradeList
                  .reduce(
                    (sum: number, trade: any) => sum + (trade.buyCost || 0),
                    0
                  )
                  .toFixed(0) || 0
              ).toLocaleString()
            : 0}
        </Cell>
        <Cell>
          {보령Data?.tradeList
            ? Number(
                보령Data.tradeList
                  .reduce(
                    (sum: number, trade: any) => sum + (trade.buyCost || 0),
                    0
                  )
                  .toFixed(0) || 0
              ).toLocaleString()
            : 0}
        </Cell>
        <Cell>
          {여수Data?.tradeList
            ? Number(
                여수Data.tradeList
                  .reduce(
                    (sum: number, trade: any) => sum + (trade.buyCost || 0),
                    0
                  )
                  .toFixed(0) || 0
              ).toLocaleString()
            : 0}
        </Cell>
      </Row>
      <Row>
        <Cell>계통 판매금액 [원]</Cell>
        <Cell>
          {Number(정읍Data?.sellGridCost?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(대전Data?.sellGridCost?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(보령Data?.sellGridCost?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(여수Data?.sellGridCost?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
      </Row>
      <Row>
        <Cell>계통 구매금액 [원]</Cell>
        <Cell>
          {Number(정읍Data?.buyGridCost?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(대전Data?.buyGridCost?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(보령Data?.buyGridCost?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(여수Data?.buyGridCost?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
      </Row>

      <Row>
        <Cell>거래전 판매 / 구매 금액 [원]</Cell>
        <Cell>
          {(() => {
            if (!정읍Data) return "0" // 데이터가 없는 경우 기본 메시지

            const {
              ifGridBuy = 0,
              totalBuyCost = 0,
              totalSellCost = 0,
              excessGen = 0,
              smp = 0,
            } = 정읍Data // 필요한 값 추출

            if (totalBuyCost > 0) {
              // totalBuyCost가 0보다 크면 ifGridBuy를 음수로 반환
              return Number((-ifGridBuy).toFixed(0)).toLocaleString()
            } else if (totalSellCost > 0) {
              // totalSellCost가 0보다 크면 excessGen * smp 계산
              return Number((excessGen * smp).toFixed(0)).toLocaleString()
            }

            // 기본값 반환
            return Number(ifGridBuy.toFixed(0)).toLocaleString()
          })()}
        </Cell>
        <Cell>
          {(() => {
            if (!대전Data) return "0" // 데이터가 없는 경우 기본 메시지

            const {
              ifGridBuy = 0,
              totalBuyCost = 0,
              totalSellCost = 0,
              excessGen = 0,
              smp = 0,
            } = 대전Data // 필요한 값 추출

            if (totalBuyCost > 0) {
              // totalBuyCost가 0보다 크면 ifGridBuy를 음수로 반환
              return Number((-ifGridBuy).toFixed(0)).toLocaleString()
            } else if (totalSellCost > 0) {
              // totalSellCost가 0보다 크면 excessGen * smp 계산
              return Number((excessGen * smp).toFixed(0)).toLocaleString()
            }

            // 기본값 반환
            return Number(ifGridBuy.toFixed(0)).toLocaleString()
          })()}
        </Cell>
        <Cell>
          {(() => {
            if (!보령Data) return "0" // 데이터가 없는 경우 기본 메시지

            const {
              ifGridBuy = 0,
              totalBuyCost = 0,
              totalSellCost = 0,
              excessGen = 0,
              smp = 0,
            } = 보령Data // 필요한 값 추출

            if (totalBuyCost > 0) {
              // totalBuyCost가 0보다 크면 ifGridBuy를 음수로 반환
              return Number((-ifGridBuy).toFixed(0)).toLocaleString()
            } else if (totalSellCost > 0) {
              // totalSellCost가 0보다 크면 excessGen * smp 계산
              return Number((excessGen * smp).toFixed(0)).toLocaleString()
            }

            // 기본값 반환
            return Number(ifGridBuy.toFixed(0)).toLocaleString()
          })()}
        </Cell>
        <Cell>
          {(() => {
            if (!여수Data) return "0" // 데이터가 없는 경우 기본 메시지

            const {
              ifGridBuy = 0,
              totalBuyCost = 0,
              totalSellCost = 0,
              excessGen = 0,
              smp = 0,
            } = 여수Data // 필요한 값 추출

            if (totalBuyCost > 0) {
              // totalBuyCost가 0보다 크면 ifGridBuy를 음수로 반환
              return Number((-ifGridBuy).toFixed(0)).toLocaleString()
            } else if (totalSellCost > 0) {
              // totalSellCost가 0보다 크면 excessGen * smp 계산
              return Number((excessGen * smp).toFixed(0)).toLocaleString()
            }

            // 기본값 반환
            return Number(ifGridBuy.toFixed(0)).toLocaleString()
          })()}
        </Cell>
      </Row>
      <Row>
        <Cell>마을간 거래 효과 [원]</Cell>
        <Cell>
          {(() => {
            if (!정읍Data) return "0" // 대전Data가 없을 경우 기본 메시지

            const { excessGen, totalSellCost, smp, benefit } = 정읍Data // 대전Data에서 값 추출

            if (excessGen > 0) {
              // 거래 전 발전량 초과일 경우

              const result = totalSellCost - excessGen * smp
              return Number(result.toFixed(0)).toLocaleString()
            } else {
              // 거래 전 발전량 부족일 경우
              return Number((benefit || 0).toFixed(0)).toLocaleString()
            }
          })()}
        </Cell>
        <Cell>
          {(() => {
            if (!대전Data) return "0" // 대전Data가 없을 경우 기본 메시지

            const { excessGen, totalSellCost, smp, benefit } = 대전Data // 대전Data에서 값 추출

            if (excessGen > 0) {
              // 거래 전 발전량 초과일 경우
              const result = totalSellCost - excessGen * smp
              return Number(result.toFixed(0)).toLocaleString()
            } else {
              // 거래 전 발전량 부족일 경우
              return Number((benefit || 0).toFixed(0)).toLocaleString()
            }
          })()}
        </Cell>

        <Cell>
          {(() => {
            if (!보령Data) return "0" // 대전Data가 없을 경우 기본 메시지

            const { excessGen, totalSellCost, smp, benefit } = 보령Data // 대전Data에서 값 추출

            if (excessGen > 0) {
              // 거래 전 발전량 초과일 경우
              const result = totalSellCost - excessGen * smp
              return Number(result.toFixed(0)).toLocaleString()
            } else {
              // 거래 전 발전량 부족일 경우
              return Number((benefit || 0).toFixed(0)).toLocaleString()
            }
          })()}
        </Cell>
        <Cell>
          {(() => {
            if (!여수Data) return "0" // 대전Data가 없을 경우 기본 메시지

            const { excessGen, totalSellCost, smp, benefit } = 여수Data // 대전Data에서 값 추출

            if (excessGen > 0) {
              // 거래 전 발전량 초과일 경우
              const result = totalSellCost - excessGen * smp
              return Number(result.toFixed(0)).toLocaleString()
            } else {
              // 거래 전 발전량 부족일 경우
              return Number((benefit || 0).toFixed(0)).toLocaleString()
            }
          })()}
        </Cell>
      </Row>
      <Row>
        <Cell>거래후 자립율 [%]</Cell>
        <Cell>
          {Number(정읍Data?.afterSubRate?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(대전Data?.afterSubRate?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(보령Data?.afterSubRate?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(여수Data?.afterSubRate?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
      </Row>
    </Wrapper>
  )
}

export default Page2Table
